import { Layout } from "antd";

import { BannerOfTheEnvIs, HeaderToGlobalLayout } from "components";

import type { ReactNode } from "react";

export function SingleLayout(props: { children: ReactNode; notHeader?: boolean }): JSX.Element {
  const { children, notHeader = false } = props;

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <BannerOfTheEnvIs />
      <Layout>
        <Layout>
          {!notHeader && <HeaderToGlobalLayout />}
          <Layout.Content style={notHeader ? { display: "flex", alignItems: "center" } : {}}>{children}</Layout.Content>
        </Layout>

        <Layout.Footer style={{ textAlign: "center" }}>Powered by heru</Layout.Footer>
      </Layout>
    </Layout>
  );
}
